<template>
  <v-footer app padless absolute v-if="!this.isMessage">
    <div class="footer-wrap">
      <div>
        ©{{  2021 }} -
        {{ new Date().getFullYear() }} By
        {{blogInfo.webSite.author}}
      </div>
      <a href="https://beian.miit.gov.cn/" target="_blank">
        {{blogInfo.webSite.recordNum}}
      </a>
      <a class="ypy-style" href="https://www.upyun.com/?utm_source=lianmeng&utm_medium=referral">
        本网站由
        <img src="@/icon/ypy_logo5.png">
        提供CDN加速
      </a>
    </div>
  </v-footer>
</template>

<script>
export default {
  computed: {
    isMessage() {
      return this.$route.path == "/message";
    },
    blogInfo() {
      return this.$store.state.blogInfo;
    }
  }
};
</script>

<style scoped>
.ypy-style {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #eee;
  font-size: 14px;

  img {
    width: 40px;
    height: 20px;
    height: 20px;
  }
}
.footer-wrap {
  width: 100%;
  line-height: 2;
  position: relative;
  padding: 40px 20px;
  color: #eee;
  font-size: 14px;
  text-align: center;
  background: linear-gradient(-45deg, #ee7752, #ce3e75, #23a6d5, #23d5ab);
  background-size: 400% 400%;
  animation: Gradient 10s ease infinite;
}
.footer-wrap a {
  color: #eee !important;
}
@keyframes Gradient {
  0% {
    background-position: 0 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0 50%;
  }
}
</style>
